import { DetailsCardData } from "../../../../components/detailsCard/detailsCard";
import AmountCard from "../amountCard/amountCard";

interface SharedAmountCardProps {
  sharedAmountData?: DetailsCardData[];
  categoryName?: string;
  levelType?: string;
}

const SharedAmountCard = (props: SharedAmountCardProps) => {
  return (
    <div className="coverage-amounts-layout">
      <div className="coverage-amounts-layout--header">
        Category - {props.categoryName}
        {props.levelType && (
          <span className={`coverage-level ${props?.levelType}`}>
            {props.levelType || ""}
          </span>
        )}
      </div>
      <div className="coverage-amounts-layout--content">
        <div className="amount-card">
          <AmountCard
            amountCardData={props.sharedAmountData ?? []}
            amountCardHeader={""}
            elementsInOneRow={2}
          />
        </div>
      </div>
    </div>
  );
};

export default SharedAmountCard;
